import { createContext } from 'react'

type CarouselContextType = {
  itemCount: number
  selectedItem: number
  moveToRight: (e: React.MouseEvent<HTMLButtonElement>) => void
  moveToLeft: (e: React.MouseEvent<HTMLButtonElement>) => void
  setItemCount: (count: number) => void
} | null

// eslint-disable-next-line import/prefer-default-export
export const CarouselContext = createContext<CarouselContextType>(null)
